import { i18n } from '@migros/msrc-i18n';
import { ArticleHeading, Box, Stack, styled } from '@migros/msrc-ui-kit';
import React from 'react';
import { Card } from '../../elements/card/Card';
import { FixedRatioContainer } from '../../elements/fixed-ratio-container/FixedRatioContainer';
import { ArticleContainer } from '../../elements/tiles/partials';
import { ListStyleType } from '../../helpers';
import { FallbackImage } from '../fallback-image';
export const Fallback = ({
  hideRating,
  mode
}) => {
  return /*#__PURE__*/React.createElement(Card, {
    as: "article",
    mode: mode,
    "data-testid": "msrc-articles--fallback",
    disableHover: true
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ArticleContainer, {
    mode: mode,
    hideRating: hideRating,
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(FixedRatioContainer, {
    paddingX: mode === ListStyleType.condensed ? undefined : ['small', 'medium'],
    paddingBottom: mode === ListStyleType.condensed ? undefined : ['large', 'xlarge']
  }, /*#__PURE__*/React.createElement(FallbackImage, null)), /*#__PURE__*/React.createElement(Stack, {
    size: ['xsmall', 'small'],
    position: ['absolute'],
    bottom: ['0'],
    left: ['0'],
    right: ['0']
  }, /*#__PURE__*/React.createElement(StyledArticleHeading, {
    as: "p",
    color: ['gray', 90],
    paddingY: "xlarge",
    sizeFont: ['xsmall', 'small'],
    lineHeight: ['tight']
  }, i18n.t('components.fallback'))))));
};
const StyledArticleHeading = styled(ArticleHeading)`
  text-align: center;
`;